module.exports = __webpack_public_path__ + "assets/viberIcon.c2c1764c.svg";